import cx from "classnames";
import { Dayjs } from "dayjs";

import { useTranslation } from "@/core/i18n";
import { formatCurrency } from "toolbox/Money";

type PromotionalExpiryLineProps = { expiryDay: Dayjs; className?: string } & (
  | { kind: "offer" }
  | { kind: "card" }
  | { kind: "expiredCard" }
  | { kind: "balance"; amountInCents: number }
);

/**
 * The one way a free promotional gift card's expiry is shown: a single line in bold capitals at
 * 14px, above the 10-point floor California sets for a promotional card's expiry date. Capitalised
 * in the text itself, so every locale reads in capitals whatever the surface's styling.
 */
export const PromotionalExpiryLine = (props: PromotionalExpiryLineProps) => {
  const { t } = useTranslation();
  const date = props.expiryDay.format("MMM D, YYYY");

  const text = (() => {
    switch (props.kind) {
      case "offer":
        return t("promotionalExpiryLine.offerExpires", { date });
      case "card":
        return t("promotionalExpiryLine.cardExpires", { date });
      case "expiredCard":
        return t("promotionalExpiryLine.cardExpired", { date });
      case "balance":
        return t("promotionalExpiryLine.balanceExpires", {
          amount: formatCurrency(props.amountInCents),
          date,
        });
    }
  })();

  return <p className={cx("text-bold2", props.className)}>{text.toLocaleUpperCase()}</p>;
};
